import { put, call, takeLatest, all } from 'redux-saga/effects';
import { COWS_FETCH_REQUEST } from './constants';
import { fetchCowsSuccess, fetchCowsFail } from './actions';
import CowAPI from './CowAPI';
import analytics from '../util/analytics';
import ScoreAdminAPI from '../admin/scoreDefinitions/ScoreAdminAPI';
// import youngBulls from './youngBulls';

// import cowData from './cowData';

// const randomNumber = () => Math.floor(Math.random() * 99) / 10;

// const names = [
//   'Warson Everly U162',
//   'Warson Boss Lad U166',
//   'Warson Elias U226',
//   'Warson Errol U189',
//   'Warson Fine Gent U200',
//   'Warson Fine Boy U122'
// ];

// const prices = [
//   2599,
//   1800,
//   900,
//   3200,
//   1400,
//   1299,
//   899,
//   2499
// ];

// const randomiseCow = (id) => {
//   const cow = { ...JSON.parse(JSON.stringify(cowData[0])), id };
//   // cow.production.qualityIndex = randomNumber();
//   // cow.eating.qualityIndex = randomNumber();
//   // cow.environment.qualityIndex = randomNumber();
//   // cow.genetic.qualityIndex = randomNumber();
//   // cow.genomic.qualityIndex = randomNumber();
//   // for (let i = 0; i < Math.floor(Math.random() * 6); i++) {
//   //   let images = JSON.parse(JSON.stringify(cow.images));
//   //   const image = images.shift();
//   //   images.push(image);
//   //   cow.images = images;
//   // }
//   cow.name = names[Math.floor(Math.random() * 6)];
//   cow.price = prices[Math.floor(Math.random() * 8)];
//   return cow;
// };

/* global performance */
function *fetch (action) {
  try {
    const start = performance.now();
    const [ animalResponse, scoresResponse ] = yield all([
      call(CowAPI.fetch),
      call(ScoreAdminAPI.fetchScores)
    ]);
    const scoreDefinitions = {};
    scoresResponse.data.scores.forEach(score => {
      scoreDefinitions[score.key] = score;
    });
    const end = performance.now();
    const time = end - start;
    analytics('send', 'timing', 'dataLoad', 'cattleLoad', time);
    yield put(fetchCowsSuccess(animalResponse.data, scoreDefinitions));
  } catch (error) {
    yield put(fetchCowsFail(error.toString()));
  }
}

function *cowSagas () {
  yield takeLatest(COWS_FETCH_REQUEST, fetch);
}

export default cowSagas;
